import React, { useEffect, useState } from 'react';

const URLProtection = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkURLSecurity = () => {
      // Skip URL checking in development mode
      if (process.env.NODE_ENV === 'development') {
        setIsAuthorized(true);
        setLoading(false);
        return;
      }

      const currentPath = window.location.pathname;
      const hash = window.location.hash;
      
      // Expected secure path structure: /wyenfos-bills/#/klzxcv
      const expectedPath = '/wyenfos-bills';
      const expectedHash = '#/klzxcv';
      
      // Check if the URL matches the secure structure
      const isSecurePath = currentPath.includes(expectedPath) && hash.includes(expectedHash);
      
      if (!isSecurePath) {
        // Redirect to secure URL or show access denied
        console.warn('Unauthorized access attempt to billing application');
        
        // Option 1: Redirect to secure URL
        window.location.href = `${window.location.origin}/wyenfos-bills/#/klzxcv`;
        
        // Option 2: Show access denied page
        return;
      }
      
      setIsAuthorized(true);
      setLoading(false);
    };

    // Check URL security on component mount
    checkURLSecurity();
    
    // Listen for URL changes
    const handleHashChange = () => {
      checkURLSecurity();
    };
    
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '3px solid rgba(255,255,255,0.3)',
          borderTop: '3px solid white',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{ marginTop: '20px', fontSize: '18px' }}>Verifying secure access...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!isAuthorized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
        color: 'white',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
        padding: '20px'
      }}>
        <h1 style={{ fontSize: '48px', margin: '0 0 20px 0' }}>🔒</h1>
        <h2 style={{ fontSize: '32px', margin: '0 0 20px 0' }}>Access Denied</h2>
        <p style={{ fontSize: '18px', margin: '0 0 30px 0', maxWidth: '500px' }}>
          This billing application requires secure access. Please use the authorized URL.
        </p>
        <button 
          onClick={() => window.location.href = `${window.location.origin}/wyenfos-bills/#/klzxcv`}
          style={{
            background: 'white',
            color: '#ee5a24',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
        >
          Go to Secure Access
        </button>
      </div>
    );
  }

  return children;
};

export default URLProtection;
